import React, { useContext } from 'react';
import classnames from 'classnames';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import DesktopDevPageStage728x90 from '@wix/da-ads/pkg/adunits/anon/DesktopDevPageStage728x90';
import UserDesktopDevPageStage728x90 from '@wix/da-ads/pkg/adunits/user/DesktopDevPageStage728x90';
import { useDeviationViewContext } from '../../../Context';
import { useSelector } from 'react-redux';
import { getCurrentAdSafety } from '../../../Ads/redux/selectors';
import { useShouldRenderAdArea } from '@wix/da-ads/pkg/useShouldRenderAdArea';
import { useAdsType } from '@wix/da-ads/pkg/useAdsType';
import PrimisTutorialsWrapper from '../../../Ads/PrimisTutorialsWrapper';
import AnonOrUserUnit from '@wix/da-ads/pkg/adunits/AnonOrUserUnit';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import s from './StageContainer.scss';
export const StageContainer = ({ children , className  })=>{
    const { isTheater , isFullscreen  } = useDeviationViewContext();
    const { isLoggedIn  } = useContext(SessionContext);
    const isLite = useFlag('ads_loggedin_lite') && isLoggedIn;
    const adSafety = useSelector((state)=>getCurrentAdSafety(state));
    const showAd = useShouldRenderAdArea(adSafety) && !isLite;
    const adsType = useAdsType();
    const hasPrimis = adsType === 'anon' && showAd;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isTheater && s['theater'], isFullscreen && s['fullscreen'], showAd && s['with-ad'], hasPrimis && s['primis'], className),
        "data-hook": BiDataHook.DEVIATION_ART_STAGE
    }, showAd && /*#__PURE__*/ React.createElement(PrimisTutorialsWrapper, {
        hasPrimis: hasPrimis !== null && hasPrimis !== void 0 ? hasPrimis : false
    }, /*#__PURE__*/ React.createElement(AnonOrUserUnit, {
        anon: DesktopDevPageStage728x90,
        user: UserDesktopDevPageStage728x90,
        safety: adSafety
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['stage-content']
    }, children));
};
StageContainer.displayName = 'StageContainer';
export default StageContainer;
